import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta';
import goTo from 'vuetify/lib/services/goto';
import {isInteger, isObject} from 'lodash';

import Home from '../pages/Home';
import PageNotFound from '../../site/pages/PageNotFound';

// App Content Library
// Auth
import Login from '../pages/auth/Login';
import LoginTwoFactor from '../pages/auth/LoginTwoFactor';
import LoginTwoFactorRecoveryCode from '../pages/auth/LoginTwoFactorRecoveryCode';
import EmailPassword from '../pages/auth/passwords/EmailPassword';
import ResetPassword from '../pages/auth/passwords/ResetPassword';
import SSOTest from '../pages/auth/SSOTest'; // MLD-2557
// Blocked Recipients
// Mailcoach Email Campaigns - MLD-2524
import MailcoachRoutes from './modules/mailcoach';

// MLD-2712
import EmailRoutes from './modules/email';

// Groups
// Labels
// Links
// Mailgun
import MailgunRoutes from './modules/mailgun';

// Nylas MLD-2221
// Presentation
// Subscription
// Team
// Teams
// User
// Users
// UserContacts
// MLD-2503
// Unlayer Email Templates
// MLD-2473
// MLD-1675
// MLD-2205
import AshfieldLetter from '../pages/clients/scilex/AshfieldLetter';

// MLD-2524
import PreviewShareTemplate from '../pages/share_templates/PreviewShareTemplate';

// MLD-2557
import {adminGuard, authGuard, employeeGuard, guestGuard, spaceGuard, teamGuard} from './guards';

// MLD-2635
import TeamMemberRoutes from './modules/teamMember';
import TeamAdminRoutes from './modules/teamAdmin';

// MLD-2752
//import incyteRoutes from './modules/clients/incyte';
// MLD-2823
import ShareTemplateRoutes from './modules/shareTemplates';

// MLD-3014
import DeviceSessionRoutes from './modules/deviceSessions';

// MLD-3298
import FaxRoutes from './modules/fax';
import FaxAdminRoutes from './modules/faxAdmin';
import FaxPublicRoutes from './modules/faxPublic';

// MLD-3900
import SnippetRoutes from './modules/snippets';

// MLD-3758
import MetabaseAdminRoutes from './modules/metabaseAdmin';

// MLD-4320
import MeilisearchAdminRoutes from './modules/meilisearchAdmin';

// MLD-4339
import AvionClientRoutes from './modules/clients/avion';

// MLD-4908, MLD-5030
import SpaceAdminRoutes from './modules/spaceAdmin';

// MLD-6016
import NeverBounceAdminRoutes from './modules/neverbounceAdmin';

// MLD-6463
import EmployeeAdminRoutes from './modules/employeeAdmin';

// MLD-6435
import SlideDeckRoutes from './modules/slideDecks';

// MLD-7490
import SinchRoutes from './modules/sinch';
import SinchAdminRoutes from './modules/sinchAdmin';

import NotAuthorized from '../pages/errors/NotAuthorized.vue';
import jitsuService from '../services/jitsuService';

import '../store';
import store from '../store';

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: '/v2/app/error/not-authorized',
    name: 'error.not_authorized',
    component: NotAuthorized,
    meta: {
      layout: 'public',
    },
  },
  // MLD-2524
  {
    path: '/v2/templates/preview',
    name: 'share_template.preview',
    component: PreviewShareTemplate,
    meta: {
      layout: 'public',
    },
  },

  ...FaxPublicRoutes, // MLD-3298
  ...authGuard([
    {
      path: '/v2',
      name: 'home',
      component: Home,
    },
    {
      path: '/login/tfa',
      name: 'login.tfa',
      component: LoginTwoFactor,
      meta: {
        layout: 'public',
      },
    },
    {
      path: '/login/tfa/recovery',
      name: 'login.tfa.recovery_code',
      component: LoginTwoFactorRecoveryCode,
      meta: {
        layout: 'public',
      },
    },
    ...DeviceSessionRoutes, // MLD-3014
    ...EmailRoutes, // MLD-2712
    ...FaxRoutes, // MLD-3298
    ...TeamMemberRoutes, // MLD-2635
    ...MailcoachRoutes, // MLD-2524
    ...MailgunRoutes,
    ...ShareTemplateRoutes,
    ...SnippetRoutes, // MLD-3900
    ...SinchRoutes, // MLD-7490
  ]),
  ...SlideDeckRoutes, // MLD-6435
  ...FaxAdminRoutes, // MLD-3298
  ...TeamAdminRoutes, // MLD-2635
  ...adminGuard([
    ...MetabaseAdminRoutes, // MLD-3758
    ...NeverBounceAdminRoutes, // MLD-6016
    ...SinchAdminRoutes, // MLD-7490
  ]),
  ...spaceGuard([ // MLD-4908, MLD-5030
    ...SpaceAdminRoutes,
  ]),
  ...employeeGuard([
    ...MeilisearchAdminRoutes, // MLD-4320
  ]),
  ...employeeGuard([ // MLD-6463
    ...EmployeeAdminRoutes,
  ]),
  ...guestGuard([
    {
      path: '/sso-test',
      name: 'sso_test',
      component: SSOTest,
      meta: {
        layout: 'public',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'public',
      },
    },
    {
      path: '/v2/login',
      redirect: '/login',
    },
    {
      path: '/v2/password/reset',
      name: 'password.request',
      component: EmailPassword,
      meta: {
        layout: 'public',
      },
    },
    {
      path: '/v2/password/reset/:token',
      name: 'password.reset',
      component: ResetPassword,
      meta: {
        layout: 'public',
      },
    },
  ]),
  ...teamGuard(211, AvionClientRoutes), // MLD-4339
  ...teamGuard(186, [
    {
      path: '/v2/app/scilex/ashfield-letter',
      name: 'app.scilex.ashfield_letter',
      component: AshfieldLetter,
      meta: {
        layout: 'mobile',
      }
    }
  ]),
  //...incyteRoutes, // MLD-2752
  {
    path: '*',
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  //base: '/v2/',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash
    } else if (isObject(savedPosition) && isInteger(savedPosition.y)) {
      scrollTo = savedPosition.y
    }
    return goTo(scrollTo)
      .catch(() => {
      }); // MLD-4885 catch exceptions
  },
});

// MLD-7340
// Track the last identified user ID
let lastIdentifiedUserID = null;
router.afterEach((to, from) => {
  try {
    const user = store.getters.user
    if (user && user.id !== lastIdentifiedUserID) {
      jitsuService.identify(user);
      lastIdentifiedUserID = user.id;
    }
    jitsuService.page()
  } catch (e) {
  }
})

router.onError(async (error) => {
  if (error?.name === 'NavigationDuplicated') { // MLD-6141
    console.log('Avoided redundant navigation:', error);
  }
  return router.replace({name: 'error.not_authorized'});
});

// MLD-6141
// @see https://chatgpt.com/c/a4d74a59-3427-4909-b4b7-d33dfba4e134
// Modify the navigation method to catch NavigationDuplicated
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((error) => {
    if (error.name !== 'NavigationDuplicated') {
      throw error;
    }
    console.log('Avoided redundant navigation:', error);
  });
};

export default router
